<template>
  <div class="container column">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/video-play.svg" width="50" alt="Minds">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <h2 class="animation-top animation-delay-02">SHOP <span>FOR ITEMS</span></h2>
        <hr class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Acumule o mdscoind e troque por itens em nossa loja!</p>
      </div>
    </div>
    <!-- <div class="box-content shadow-box box-content-border relative hidden min-height container">
      <div class="box--item animation-bottom animation-delay-05 list flex-grow-1 container column">

        <div class="list__content container">

          <div class="list__content__item flex-grow-1 flex-basis-200 container justify-content-center align-center"
               v-for="p in products"
               :class="{ disabled: !p || coins < p.price }">

            <div style="background: rgb(220, 62, 16); border-radius: 20px;">
              <div class="list__content__item__name" v-if="!!p">
                <p>{{ p.name }}</p>
              </div>

              <div class="list__content__item__description flex-grow-1" v-if="!!p">
                <p>{{ p.description }}</p>
              </div>

              <div class="list__content__item__price container justify-content-center align-center" v-if="!!p">
                <p>price</p>
                <span class="container">
                  <img src="@/assets/img/coin.svg" alt="Minds EAD Coins">
                  {{ p.price }}
                </span>
              </div>
            </div>

            <div class="list__content__item__action" v-if="!!p">
              <button class="btn btn-full btn-gradient-blue btn-rounded" :class="{ disabled: coins < p.price }" @click="buy(p)" :disabled="coins < p.price">
                Buy
              </button>
            </div>

          </div>

        </div>

        <div class="list__paging container align-center" v-if="_products_.length > 3">
          <div class="list__paging__pages">
            <span @click="prevPage()" :disabled="!allowBack">
              <font-awesome-icon icon="caret-left"/>
            </span>
            <span
              v-for="p in Math.ceil(parseInt(_products_.length) / 3)"
              :class="{ current: (p - 1) == page }"
              @click="page = (p - 1)"
            >
              {{ p }}
            </span>
            <span @click="nextPage()" :disabled="!allowNext">
              <font-awesome-icon icon="caret-right"/>
            </span>
          </div>
        </div>

      </div>
      <modal ref="modal" :show="showAlert" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
        <modalPurchase :product="product" :close="emitClose"/>
      </modal>
    </div> -->
    <div class="box-content shadow-box box-content-border hidden min-height container justify-content-center align-items-center">

      <div class="box--item animation-bottom animation-delay-05">
        <h4>COMING SOON</h4>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import modal from "@/components/modal";
  import modalBus from "@/components/modal/modalBus";
  import modalPurchase from "@/components/modal/modalPurchase";

  export default {
    name: 'Store',
    data () {
      return {
        product: null,
        page: 0,
        showAlert: false
      }
    },
    computed: {
      ...mapGetters({
        _products_: 'store/getAll',
        student: 'student/GET'
      }),
      products () {
        const temp = [ ...this._products_.slice(this.page * 3, 3 * (this.page + 1)) ]

        while (temp.length < 4) {
          temp.push(null)
        }

        return temp
      },
      allowBack () {
        return this.page > 0
      },
      allowNext () {
        return this.page < Math.trunc(this._products_.length / 3)
      },
      coins () {
        return this.student.coins
      }
    },
    components: {
      modal,
      modalPurchase
    },
    methods: {
      nextPage () {
        if (this.allowNext) this.page++
      },
      prevPage () {
        if (this.allowBack) this.page--
      },
      buy (product) {
        this.product = product
        this.showAlert = true
      },
      confirmPayment () {
        this.$store.dispatch('store/buy', this.product)
      },
      closeModal() {
        this.showAlert = false;
      },
      emitClose() {
        this.$refs["modal"].close();
      }
    },
    mounted() {
      modalBus.$on("close", this.closeModal);
    },
    beforeDestroy() {
      modalBus.$off("close", this.closeModal);
    }
  }
</script>

<style lang="scss" scoped>
  .list {
    padding: 0;
    &__content {
        flex-wrap: wrap;
      &__item {
        margin: 15px;
        // padding: 10px;
        border-radius: 10px;
        // background-color: #E8E8E8;
        transition: all .2s;
        flex-direction: column;
        min-width: 200px;
        cursor: pointer;
        &:hover {
          // background-color: rgb(104, 34, 34);
          filter: brightness(.8);
          transform: scale(1.1)
        }
        &.disabled {
          cursor: not-allowed;
          // background-color: #E4E4E4;
          // color: #888;
          filter: grayscale(1);
        }
        &__name{
          background: #FF7E56;
          color: white;
          height: 150px;
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          box-shadow: inset 2px -110px 67px -77px #d63300;
          p { font-size: 40px;}
        }
        &__description {
            text-align: left;
            padding: 20px;
            background: #FFC9B8;
            font-weight: 200;
            color: #d63300;
            border-radius: 40px 0px 0px 0px;
            line-height: 20px;
        }
        &__price {
          background: #FFC9B8;
          // padding: 0px 10px 0px 0px;
          border-radius: 0px 0px 10px 10px;
          justify-content: space-between;
          img  {
            width: 25px;
            margin-right: 10px;
            }
          span {
            font-size: 28px;
            background: #FF7E56;
            padding: 15px 25px;
            border-radius: 30px 0px 10px 0px;
            }
          p {
            background: #FFC9B8;
            padding: 15px;
          }
        }
        &__action {
          // background: red;
          margin-top: 10px;
          width: 100%;
          button {
            padding: 10px 30px;
            font-size: 18px !important;
          }
        }
      }
    }
    &__paging {
      &__pages {
        text-align: center;
        display: flex;
        span {
          cursor: pointer;
          display: flex;
          border-radius: 25px;
          background-color: #DDD;
          margin: 5px 5px;
          width: 34px;
          height: 34px;
          justify-content: center;
          align-items: center;
          &.current {
            background-color: #BBB;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/index.vue